import classNames from 'clsx';
import React, { memo } from 'react';
import { type TitleVariants, getTitleIcon } from 'reactApp/ui/Subscriptions/Subscriptions.utils';

import styles from './SubscriptionListItem.css';

type Props = {
    icon: string;
    title: string;
    description: string;
    errorDescription?: string;
    type?: string;
    onClick?: () => void;
    showWaiting?: boolean;
    titleVariant?: TitleVariants;
    isDisable?: boolean;
    isRebranding?: boolean;
    isRebrandingQuotaLanding?: boolean;
};

export const SubscriptionItem = memo<Props>(
    ({
        icon,
        title,
        description,
        errorDescription,
        onClick,
        type = 'default',
        isDisable,
        showWaiting,
        titleVariant,
        isRebranding = false,
        isRebrandingQuotaLanding,
    }) => (
        <div
            className={classNames(styles.root, {
                [styles[`root_${type}`]]: type,
                [styles.root_disable]: isDisable,
                [styles.root_rebranding]: isRebranding,
                [styles.root_rebrandingQuotaLanding]: isRebrandingQuotaLanding,
                [styles.root_height_auto]: errorDescription,
            })}
            onClick={onClick}
        >
            <div className={styles.content}>
                <p className={styles.title}>
                    {getTitleIcon(titleVariant)} {title}
                </p>
                {errorDescription && <p className={classNames(styles.description, styles.error)}>{errorDescription}</p>}
                <p className={classNames(styles.description, { [styles.waiting]: showWaiting })}>{description}</p>
            </div>
            <img src={icon} className={styles.icon} width={28} height={28} />
        </div>
    )
);

SubscriptionItem.displayName = 'SubscriptionItem';
